module.exports = {
	"basics": {
		"name": "Dr. Weyrich Joy",
		"label": "Médecin spécialiste en gynécologie et obstétrique ",
		"picture": "./profile.jpg",
		"email": "contact@drweyrich.lu",
		"phone": "+352 54 68 55",
		"fax": "+352 54 41 08 ",
		"website": "https://www.bobmolitor.info",
		"summary": "",
		"location": {
			"address": "179, rue de Luxembourg ",
			"postalCode": "4222",
			"city": "Esch-sur-Alzette ",
			"countryCode": "LU",
			"region": ""
		},
		"tec_contact": "info@bobmolitor.info"
	},
	"cookie": "Notre site utilise des cookies. En cliquant sur le bouton 'Accepter', vous acceptez l'utilisation de cookies.",
	"consultations": [
		{
			"label": "Lundi",
			"start": "09:00 - 11:30 et",
			"end": "13:00 - 15:00"
		},
		{
			"label": "Mardi",
			"start": "09:00 -",
			"end": "17:00"
		},
		{
			"label": "Mercredi",
			"start": "08:30",
			"end": "12:00"
		},
		{
			"label": "Jeudi",
			"start": "08:30 - 11:30 et ",
			"end": "13:00 - 15:00"
		}
	],
	"urgences": {
		"text": "Pour toute urgence veuillez téléphoner au 112 ou bien au service d'urgences du",
		"linkText": "CHEM",
		"link": "http://www.chem.lu/patients-et-visiteurs/urgences/informations-pratiques"
	},
	"liens": [
		{
			"label": "Gynécologues agréés au Centre Hospitalier Emile Mayrisch",
			"linkText": "www.chem.lu",
			"link": "http://www.chem.lu/specialites-et-services-de-support/gynecologie-esch"
		},
		{
			"label": "Caisse Nationale de Santé",
			"linkText": "www.cns.lu",
			"link": "http://www.cns.lu/"
		},
		{
			"label": "Pharmacie de garde",
			"linkText": "www.pharmacie.lu",
			"link": "http://www.pharmacie.lu/"
		},
		{
			"label": "Portail des secours",
			"linkText": "www.112.public.lu",
			"link": "http://www.112.public.lu/"
		},
		{
			"label": "Site des institutions de sécurité sociale luxembourgeoises",
			"linkText": "www.secu.lu",
			"link": "http://www.secu.lu/"
		},
		{
			"label": "Hôpitaux de garde",
			"linkText": "sos.luxweb.lu/fr/hopitaux-de-garde",
			"link": "sos.luxweb.lu/fr/hopitaux-de-garde"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/resume.json
// module id = 305
// module chunks = 0